// src/data/firebase.js
// Initialize Firebase once, export both `app` and `db`.

import { initializeApp, getApps, getApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBLeNq6R6w4SjOUJaHPG6bePpXS2csydiM",
  authDomain: "tinting-website-cfabc.firebaseapp.com",
  projectId: "tinting-website-cfabc",
  storageBucket: "tinting-website-cfabc.firebasestorage.app",
  messagingSenderId: "934635698315",
  appId: "1:934635698315:web:7de1d1631fed276b343c8e",
};

// Avoid duplicate init during hot reloads
const app = getApps().length ? getApp() : initializeApp(firebaseConfig);
const db = getFirestore(app);

export { app, db };
